import InlineSVG from 'react-inlinesvg';
import infoIcon from '../assets/svg/link-new-tab.svg';

const PatientDocumentInfoTextTooltip = ({
    lang,
    className = '',
    text,
    style = {},
}) => {
    return (
        <div className={`patient-documents-info-text-tooltip-container ${className}`} style={style}>
            <InlineSVG src={infoIcon} />
            <span>{(text ?? 'If enabled, the patient will be able to access the document when signed in. Notifications to the patient can be managed by the clinic-admin.').translate(lang)}</span>
        </div>
    )
}

export default PatientDocumentInfoTextTooltip